import React from 'react';
import cx from 'classnames';
import { useIntl } from 'react-intl';
// import picture from '~public/images/cleaning-services.jpg';
// import pictureWebp from '~public/images/cleaning-services.jpg?format=webp';

import picture from '~public/images/juanpescador.com-domestic-care.jpg';
import pictureWebp from '~public/images/juanpescador.com-domestic-care.jpg?format=webp';

// import pictureMob from '~public/images/cleaning-services-mob.jpg';
// import pictureWebpMob from '~public/images/cleaning-services-mob.jpg?format=webp';

import pictureMob from '~public/images/juanpescador.com-cleaning-housekeeping.jpg';

import './style.scss';

const Wrapper = ({ children, className }) => {
  const intl = useIntl();

  //  const displayStyle = hasImageLoaded && isMobile ? 'block' : 'none';
  //  style={{ display: displayStyle }}

  return (
    <div className={cx('c-hero-hp', { [className]: !!className })}>
      <div className="c-hero-hp__inner">
        {/*  <div className={`c-hero-hp__background ${!hasImageLoaded && 'fallback-size'}`}> */}

        {/* <div className="c-hero-hp__title"> */}
        {/* <h1 className="l-headline--primary c-hero-hp__title-mobile">
          {intl.formatMessage({
            id: 'containers.homepage.seo.hero.title',
            defaultMessage: 'Find a great cleaner or client without hassle',
          })}
        </h1> */}
        <div className={`c-hero-hp__background`}>
          <div className="c-hero-hp__gradient-overlay-old"></div>
            <picture className="c-hero-hp__img">
                {/* Desktop */}
                <source
                    media="(min-width: 768px)"
                    type="image/webp"
                    srcSet={pictureWebp.srcSet}
                />
                <source
                    media="(min-width: 768px)"
                    type="image/jpeg"
                    srcSet="/public/images/36323ac-1920.jpg"
                />
                {/* Mobile */}
                <source
                    media="(max-width: 767px)"
                    type="image/webp"
                    srcSet={pictureMob.srcSet}
                />
                <source
                    media="(max-width: 767px)"
                    type="image/jpeg"
                    srcSet="/public/images/c1a2a85-414.jpg"
                />
                <img
                    src={picture.src}
                    alt="Juan Pescador"
                    width="810"
                    height="682"
                    fetchpriority="high"
                    loading="eager"
                    decoding="async"
                    style={{ width: "100%" }}
                />
            </picture>
          {/* <picture className="c-hero-hp__img c-hero-hp__img__desk">
            <source srcSet={pictureWebp.srcSet} type="image/webp" />
            <img src={picture.src} srcSet={picture.srcSet} width="810" height="682" alt='Juan Pescador' />
          </picture> */}
          {/* <picture className={`c-hero-hp__img c-hero-hp__img__mob`} >
            <source srcSet={pictureWebpMob.srcSet} type="image/webp" />
            <img  ref={imgRef} src={pictureMob.src} srcSet={pictureMob.srcSet} onLoad={onLoadImg} width="360" height="240" alt='Juan Pescador' fetchpriority="high" />
          </picture> */}
        </div>
          <div className="c-hero-hp__content">{children}</div>
      </div>
    </div>
  );
};


const Title = ({ children, className }) => {
  return (
    <div className={cx('c-hero-hp__title', { [className]: !!className })}>
      <h1 className="l-headline--primary">{children}</h1>
    </div>
  );
};
const Subtitle = ({ children, className }) => {
  return <div className={cx('c-hero-hp__subtitle', { [className]: !!className })}>{children}</div>;
};

const Ticks = ({ children, className }) => {
  return <div className={cx('c-hero-hp__ticks', { [className]: !!className })}>{children}</div>;
};

const Postcode = ({children}) => {
  return (
    <div className="c-hero-hp__srarch">
      <div className="search-filt">{children}</div>
    </div>
  );
};

const Intro = ({ children }) => {
  return <div className="c-hero-hp__intro">{children}</div>;
};

const Buttons = ({ children }) => {
  return <div className="c-hero-hp__buttons">{children}</div>;
};


export default {
  Wrapper,
  Title,    
  Intro,
  Postcode,
  Buttons,
  Subtitle,
  Ticks,
};